/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import i18n from 'i18next';

// Component imports
import { Button, Space } from 'antd';

// Misc imports
import { NAV_LOGIN } from './navigation';
import { SUPPORT_EMAIL } from './env';

export const LIVECHAT_ERROR_CODES = {
  /* Error unknown */
  LCM_000: 'An error occurred.',
  /* Fires when an agent tries to accept a request that is already accepted by another livechat agent */
  LCM_001: 'This request has been accepted by another LiveChat Agent.',
  /* Security. Fires when a user tries to handle conversations or messages of an organization they are not in */
  LCM_002: `You don't have access to this conversation.`,
  /* Fires when the claimed message sender is not included in the conversation the message is sent to*/
  LCM_003: 'An error occurred while receiving a message.',
  /* Fires when the specified request is not found by the referred id */
  LCM_004: 'Request not found.',
  /* Generic error that specifies that a socket action has failed */
  LCM_005: 'An error occurred while handling the event.',
  /* Error that indicates the user object is not found. This indicates a quirky behaviour and should be reported */
  LCM_006: `We couldn't find this user.`,
  /* Fires when a conversation does not exist */
  LCM_007: 'The conversation you tried accessing does not exist.',
  /* Fires when bot fails to accept a new conversation */
  LCM_008: 'The agent failed to accept your request. Try again!',
  /* Fires when a user tries to make a transfer request for a conversation, more than once */
  LCM_009: 'There is already a pending transfer request for this conversation.',
  /* Fires when an agent tries to make a transfer request to themselves */
  LCM_010: 'You can\'t transfer a conversation to yourself.',
  /* Fires when conversation is finished */
  LCM_011: 'This conversation has ended.'
};

export const AUTH_ERROR_CODES = {
  /* Invalid email or password */
  'HBF-AUTH-0001': `${i18n.t('We couldn\'t log you in. The email or password you entered did not match our records. Please check and try again.')}`,
  'HBF-AUTH-0003': `${i18n.t('We couldn\'t log you in. We can\'t find an account with this email address. Please check and try again.')}`,
  'HBF-AUTH-0005': `${i18n.t(`For your security, your account has been locked after multiple failed login attempts. To restore access, please reach out to Helvia Support at ${SUPPORT_EMAIL}.`)}`,
  'HBF-REQ-0005': (
    <Space size={0}>
      {i18n.t('Looks like there is already an account with this email address. You can ')}
      <Button
        type="link"
        className="pl-1 pr-1"
        onClick={() => {
          // redirect to console login (base url /login)
          window.location.href = `${window.location.origin}${NAV_LOGIN}`;
        }}
      >
        {i18n.t('login')}
      </Button>
      {i18n.t('with your existing account.')}
    </Space>
  )
};

export const USER_ERROR_CODES = {
  /* User already exists */
  duplicateEmail: {
    code: 'HBF-REQ-0005',
    message: 'A user with the specified email already exists.'
  },
  /* Password confirmation mismatch */
  passwordMismatch: {
    code: 'HBF-REQ-0006',
    message: 'New password doesn\'t match with the confirmation one.'
  },
  /* Current password is invalid */
  invalidPassword: {
    code: 'HBF-REQ-0007',
    message: 'The current password is invalid.'
  }
};

export const OPTIMISTIC_LOCKING_EXCEPTION_ERROR_CODE = 'HBF-DATA-0002';
